<div class="container-footer">
  <div class="grid grid-cols-3 grid-rows-1 justify-items-center">
    <div class="tk-c-gray text-2xs justify-self-start self-center ml-8">
      {{'login-footer.version' | translate}} {{version}}
    </div>
  
    <div class="flex place-items-center">
      <div class="grid ">
        <div class="i-tekom-logo"></div>
      </div>
  
      <span class="ml-2.5 text-2xs">
        <div class="tk-c-gray leading-3">{{'login-footer.contact-in-case-of-problems' | translate}}</div>
        <div class="leading-3">
          <a href="mailto:{{'contact.email' | translate}}?subject={{'contact.email-subject' | translate}}">
            <span class="tk-c-blue">{{'contact.email' | translate}},</span>
          </a>
          <a href="tel:{{'contact.phone-no-spaces' | translate}}">
            <span class="text-black ml-1">{{'contact.phone' | translate}}</span>
          </a>
        </div>
      </span>
    </div>
  
    <div *ngIf="isLanguageSwitchVisible" class="justify-self-end mr-8">
      <am-select-language></am-select-language>
    </div>
  </div>

  <div class="container-footer__mobile-app">
    <div class="container-footer__mobile-app__img-wrapper">
      <div class="container-footer__mobile-app__img-wrapper__shadow-white"></div>

      <div class="qr-code-wrapper">
        <div class="qr-code-wrapper__img">
          <img src="/assets/img/qr-code-download-app.png" alt="qr code download app">
        </div>
        <div class="qr-code-wrapper__shadow"></div>
      </div>
    </div>
    <h1 class="container-footer__mobile-app__title">
      {{ 'login-footer.use-it-on-mobile' | translate }}
    </h1>
    <a target="_blank" href="https://apps.apple.com/us/app/mycar-gps/id1626485264" class="img-download">
      <img src="/assets/img/app-store.svg" alt="app-store">
    </a>
    <a target="_blank" href="https://play.google.com/store/apps/details?id=pl.tekom.mycarbusiness&pcampaignid=web_share" class="img-download">
      <img src="/assets/img/google-play.svg" alt="google play">
    </a>
  </div>
</div>
